<template>
  <div class="menu-translations-tooltip">
    <div class="tooltip-header">
      <div class="qrw-heading-xs bold v1-grey-10-color w-100">
        {{ $t("menu_languages.settings_title") }}
      </div>
      <BaseButton
        size="sm"
        icon="x"
        @click="$emit('close')"
        color="v1-grey-8"
      />
    </div>
    <div class="tooltip-languages">
      <MenuTranslationTooltipRow
        v-model="menuLocaleModel"
        isOriginal
        @edit="$emit('edit')"
        :locale="menu.original_locale"
      />

      <MenuTranslationTooltipRow
        v-for="locale in menu.locales"
        :key="locale"
        :locale="locale"
        v-model="menuLocaleModel"
        @delete="deleting_locale = locale"
      />
      <div class="add-translation-block">
        <BaseButton
          variant="secondary"
          class="w-100"
          icon="plus"
          size="md"
          @click="$emit('add')"
          color="v1-grey-10"
        >
          {{ $t("menu_languages.btn_add") }}
        </BaseButton>
      </div>
    </div>
    <div class="tooltip-option">
      <div class="gap-column-xs tooltip-option-header">
        <div class="qrw-label-lg bold v1-grey-10-color w-100">
          {{ $t("menu_languages.preview_title") }}
        </div>
        <IQOSToggle v-model="menuUiTranslationPreview" />
      </div>

      <div class="qrw-paragraph-md-sm v1-grey-7-color">
        {{ $t("menu_languages.preview_desc") }}
      </div>
    </div>

    <DangerConfirmModal
      @cancel="deleting_locale = null"
      @confirm="deleteLocale"
      v-if="deleting_locale"
    >
      {{ $t('menu_languages.remove_language_confirm') }}
    </DangerConfirmModal>
  </div>
</template>

<script>
import MenuTranslationTooltipRow from '@/components/menu/MenuTranslationTooltipRow.vue'

import DangerConfirmModal from '@/components/modals/DangerConfirmModal.vue'

export default {
  components: {
    MenuTranslationTooltipRow,
    DangerConfirmModal
  },
  data() {
    return {
      a: false,
      deleting_locale: false
    }
  },
  methods: {
    deleteLocale() {
      this.$store.commit('menu/deleteLocale', this.deleting_locale)
      this.$store.commit('menu/setCurrentLocale', null)
      this.$store.dispatch('menu/save')

      this.deleting_locale = null
    }
  },
  computed: {
    menu() {
      return this.$store.state.menu.current
    },
    menuUiTranslationPreview: {
      get() {
        return this.$store.state.menu.ui_translation_preview
      },
      set(v) {
        this.$store.commit('menu/setUiTranslationPreview', v)
      }
    },
    menuLocaleModel: {
      get() {
        return this.$store.state.menu.current_locale
      },

      set(v) {
        if (v == this.menu.original_locale) {
          this.$store.commit('menu/setCurrentLocale', null)
        } else {
          this.$store.commit('menu/setCurrentLocale', v)
          this.$store.commit('menu/postFixModificatorsLocalizations')
        }
      }
    }
  }
}
</script>

<style scoped>
.menu-translations-tooltip {
  width: 320px;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  overflow: hidden;
  background: var(--v1-grey-2-color);
}

.tooltip-header {
  display: flex;
  flex-direction: row;
  column-gap: 8px;
  background: var(--v1-grey-2-color);
  padding: 12px 12px 12px 16px;
  align-content: center;
  align-items: center;
}

.tooltip-languages {
  max-height: 60vh;
  overflow-y: auto;
  background: var(--v1-grey-2-color);
}

.add-translation-block {
  background: var(--v1-grey-1-color);
  padding: 16px;
  width: 100%;
  box-sizing: border-box;
}

.tooltip-option {
  padding: 16px;
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  background: var(--v1-grey-2-color);
}

.tooltip-option-header {
  display: flex;
  align-items: center;
}

.tooltip-languages {
  max-height: 500px;
  overflow-y: auto;
}
</style>
